export default __webpack_public_path__ + "47c3ae8dd3d1b5e3bcf692392c99d901.json";